module.exports = __webpack_public_path__ + "static/media/ana-lucena-3.0fdd3f02.jpeg";